<template>
<!--<div v-if="loading" id="loading" class="loading_ios">
    <div class="load_table">
        <span id="loadingANI" :class="{'iconLoadingL': loading }">
          <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" width="39px" height="39px" viewBox="-7.5 0 39 39" enable-background="new -7.5 0 39 39" style="">
            <path fill="#FFF" d="M12,39C1.248,39-7.5,30.252-7.5,19.5C-7.5,8.748,1.248,0,12,0c10.752,0,19.5,8.748,19.5,19.5
              c0,0.596-0.482,1.078-1.078,1.078s-1.078-0.482-1.078-1.078c0-9.563-7.781-17.344-17.344-17.344C2.437,2.156-5.344,9.937-5.344,19.5
              c0,9.562,7.781,17.344,17.344,17.344c6.137,0,11.88-3.299,14.986-8.609c0.301-0.515,0.96-0.688,1.476-0.386
              c0.515,0.301,0.688,0.961,0.387,1.475C25.356,35.292,18.9,39,12,39z"></path>
          </svg>
        </span>
    </div>
</div>-->

<div v-if="loading" id="loading" class="loading">
    <i class="icon_load"></i>
</div>

</template>

<script>
export default {
    props: {
        loading: false,
    },
    data() {
        return {}
    },
    mounted() {}
}
</script>



// WEBPACK FOOTER //
// resources/mhg/vue/components/loadingScreen.vue